import { Dialog, DialogClose, DialogHeader, DialogText, DialogTitle } from "./ChatwootHint.styled";

interface ChatwootHintProps {
  opened: boolean;
  setOpened: (param: boolean) => void;
}

const ChatwootHint = ({ opened, setOpened }: ChatwootHintProps) => {
  const handleClose = () => setOpened(false);
  return (
    <Dialog opened={opened}>
      <DialogHeader>
        <DialogTitle>Вас приветствует{"\n"}Онлайн-центр обслуживания клиентов.</DialogTitle>
        <DialogClose onClick={handleClose}>&times;</DialogClose>
      </DialogHeader>
      <DialogText>Здесь вы можете решить все вопросы по коммунальным услугам дистанционно.</DialogText>
    </Dialog>
  );
};

export default ChatwootHint;
